// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"475":"a83e5e48","689":"0a2c39e4"}[chunkId] + ".chunk.js";
};